import { StatusBar } from "expo-status-bar";
import React from "react";
import { StyleSheet, View } from "react-native";

import { Image, Input, Button, Text } from "react-native-elements";

import { auth } from "../firebase";

export default function RegisterScreen({ navigation }) {
  const [full_name, set_full_name] = React.useState("");
  const [email, set_email] = React.useState("");
  const [mobile, set_mobile] = React.useState("");
  const [password, set_password] = React.useState("");

  const register = () => {
    auth
      .createUserWithEmailAndPassword(email, password)
      .then((auth_user) =>
        auth_user.user.updateProfile({
          displayName: full_name,
          photoURL: "https://i.pravatar.cc/150",
        })
      )
      .catch((error) => alert(error.message));
  };

  React.useLayoutEffect(() => {
    navigation.setOptions({
      headerBackTitle: "Back to Login",
    });
  }, [navigation]);

  return (
    <View style={styles.container}>
      <StatusBar style="light" />
      <Text h3 style={{ marginBottom: 30 }}>
        Create an account
      </Text>

      <View style={styles.input_container}>
        <Input
          placeholder="Full Name"
          type="text"
          value={full_name}
          onChangeText={(new_full_name) => set_full_name(new_full_name)}
        />
        <Input
          placeholder="Email"
          type="email"
          value={email}
          onChangeText={(new_email) => set_email(new_email)}
        />
        <Input
          placeholder="Mobile"
          type="text"
          value={mobile}
          onChangeText={(new_mobile) => set_mobile(new_mobile)}
        />
        <Input
          placeholder="Password"
          type="password"
          secureTextEntry
          value={password}
          onChangeText={(new_password) => set_password(new_password)}
        />
        <View style={styles.buttons}>
          <Button
            title="Register"
            onPress={register}
            buttonStyle={{
              margin: 5,
            }}
          />
        </View>
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    alignItems: "center",
    justifyContent: "center",
  },
  input_container: {
    width: "90%",
    alignItems: "center",
    justifyContent: "center",
  },
  buttons: {
    width: "70%",
  },
});
